<template>
  <ul>
    <li
      v-for="child in children"
      :key="child.uuid"
    >
      - {{ child.attributes.title }}
      <RecursiveFolder
        v-if="child.tree"
        :children="child.tree.data"
        :level="level + 1"
      />
    </li>
  </ul>
</template>

<script type="text/babel">
export default {
  name: 'RecursiveFolderSelectOption',
  props: {
    children: {
      type: Array,
      required: false,
      default: () => [],
    },
    level: {
      type: Number,
      required: true,
    },
  },
  methods: {
    hasChildren(folder) {
      return folder.hasOwnProperty('tree')
    },
  },
}
</script>
